





































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import StringUtils from '@/utils/StringUtils';
import VueI18n from 'vue-i18n';
import TranslateResult = VueI18n.TranslateResult;

@Component
export default class DataTable extends Vue {
  @Prop({default: ''}) private readonly id: string;
  @Prop({default: ''}) private readonly title: string;
  @Prop({default: () => []}) private readonly values: any[];
  @Prop({default: '0px'}) private readonly tableWidth: string;
  @Prop({default: ''}) private readonly tableBodyHeight: string;
  @Prop({default: 0}) private readonly columnLength: number;
  @Prop({default: ''}) private readonly tableBodyClass: string;
  @Prop({default: null}) private readonly noDataText: TranslateResult;
  @Prop({default: false}) private readonly loading: boolean;

  get componentId() {
    return this.id ? this.id : `data-table-${Math.floor(Math.random() * 1000000)}`;
  }

  get tableTitle() {
    return this.title;
  }

  get tableStyles() {
    return {
      minWidth: this.tableWidth
    };
  }

  get colspan() {
    return this.columnLength;
  }

  get getTableBodyWrapStyle() {
    return StringUtils.hasValue(this.getTableBodyHeight) ? {height: this.getTableBodyHeight} : {};
  }

  get getTableBodyHeight() {
    return this.tableBodyHeight;
  }

  get getTableBodyClass() {
    return this.tableBodyClass;
  }

  get getNoDataText(): TranslateResult {
    return this.noDataText ?? this.$t('message.noDataText');
  }

  get isLoading() {
    return this.loading;
  }
}
